import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL } from "@/lib/site";
import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

const CABINS = [
  {
    title: "2-Room Cabin",
    body: "A furnished cabin with a separate bedroom and living area. Available amenities include a full-size refrigerator, sink, stove, full bathroom with shower, coffee maker, and microwave.",
  },
  {
    title: "Small Cabin",
    body: "A comfortable cabin-style accommodation with two queen beds in one spacious room. Available conveniences include a coffee maker, mini refrigerator, microwave, television, and private restroom.",
  },
] as const;

export function CabinsSection() {
  const photo = PHOTOS.parkModelPatio;

  return (
    <section
      id="cabins"
      className="scroll-mt-28 texture-paper bg-background py-24 sm:py-28 lg:py-32"
      aria-labelledby="cabins-title"
    >
      <div className="mx-auto grid max-w-[1400px] items-start gap-14 px-4 sm:px-6 lg:grid-cols-[1fr_1.1fr] lg:gap-20 lg:px-10">
        <MaskReveal className="media-zoom rounded-sm lg:sticky lg:top-28">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes={PHOTO_SIZES.half}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[4/3] w-full rounded-sm object-cover"
          />
        </MaskReveal>

        <div>
          <Reveal>
            <p className="eyebrow text-clay">A Little More Room</p>
            <h2
              id="cabins-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Cabins for Comfortable South Texas Stays
            </h2>
          </Reveal>

          <div className="mt-10 space-y-10">
            {CABINS.map((cabin, i) => (
              <Reveal key={cabin.title} delay={i * 0.08}>
                <article className="rule-sand pt-6">
                  <h3 className="font-display text-2xl text-forest-deep">{cabin.title}</h3>
                  <p className="mt-3 text-base leading-relaxed text-muted-foreground">
                    {cabin.body}
                  </p>
                </article>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.16} className="mt-8">
            <p className="text-sm leading-relaxed text-muted-foreground">
              Accommodation features can vary. Guests should review the current listing details
              during the reservation process or contact the park with questions.
            </p>
          </Reveal>

          <Reveal delay={0.2} className="mt-8">
            <Button asChild variant="book" size="cta">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
                Check Cabin Availability <ArrowUpRight aria-hidden="true" />
              </a>
            </Button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
